import React from 'react';
import s from './LogsFeedItemList.module.css';

interface IFeedItem {
    logId: string;
    userEmail: string;
    userId: number;
    userName: string | null;
    collageUrl: string;
    styleName: string;
    styleId: number;
    fashionGuid: string;
    startView: string;
    endView: string;
    viewingDuration: number;
}

interface Props {
    log: IFeedItem;
}

export default function LogsFeedItemList({ log }: Props) {
    return (
        <div className={s.collage}>
            <img
                src={log.collageUrl}
                alt={`Коллаж ${log.styleName}`}
                className={s.collageImage}
            />

            <div className={s.info}>
                <div className={s.userInfo}>
                    <span className={s.userName}>{log.userName || 'Аноним'}</span>
                    <span className={s.userEmail}>{log.userEmail}</span>
                </div>

                <div className={s.styleInfo}>
                    <span className={s.styleName}>{log.styleName}</span>
                </div>

                <div className={s.duration}>
                    ⏱ {log.viewingDuration} сек.
                </div>

                <div className={s.meta}>
                    <span className={s.fashionGuid}>GUID: {log.fashionGuid.slice(0, 8)}...</span>
                </div>
            </div>
        </div>
    );
}